<template>
  <div class="animated fadeIn report main-div">
    <vLoading v-if="vLoading" />
    <div class="pe-6 ps-6 py-10">
      <v-row dir="ltr" class="pb-2">
        <v-col class="text-sm-left text-center">
          <v-btn
            to="/admin/advancedReport"
            class="bc-primary text-white no-underline"
            elevation="0"
            width="230"
            ><span class="c-light">بازگشت به صفحه اصلی</span></v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center fs-xlarge c-dark pt-sm-0 pt-6"
          ><span>گزارش موضوعات زیست فناوری</span></v-col
        >
      </v-row>
      <hr class="my-4" />
      <div class="d-lg-block d-none">
        <v-stepper v-model="stepNumber" alt-labels>
          <v-stepper-header>
            <v-stepper-step
              :complete="stepNumber > 1"
              :active-icon="'mdi-pen'"
              step="1"
            >
              <div @click="stepNumber = 1" class="text-center pointer">
                <p class="fs-xsmall mb-3">گام اول</p>
                <p class="mb-0">انتخاب موضوعات</p>
                <div v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
                  (
                  <span v-if="selectedCats.length">
                    {{ selectedCats.length + " موضوع" }}
                  </span>
                  )
                </div>
              </div>
            </v-stepper-step>

            <v-divider :class="stepNumber > 1 ? 'completed' : ''"></v-divider>

            <v-stepper-step step="2">
              <div class="text-center">
                <p class="fs-xsmall mb-3">گام دوم</p>
                <p class="mb-0">مشاهده و خروجی گزارش</p>
              </div>
            </v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </div>
      <div class="d-lg-none d-sm-block d-none pt-4">
        <div class="d-flex flex-row justify-content-center c-grey">
          <div
            class="text-center pointer"
            @click="stepNumber = 1"
            :class="stepNumber == 1 ? 'c-pink' : 'c-primary'"
          >
            <span>انتخاب موضوعات</span>
            <div v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
              (
              <span v-if="selectedCats.length">
                {{ selectedCats.length + " موضوع" }}
              </span>
              )
            </div>
          </div>
          <div class="text-center">
            <v-icon class="mx-5">mdi-chevron-left</v-icon>
          </div>

          <div>
            <v-icon class="mx-5">mdi-chevron-left</v-icon>
          </div>
          <div>
            <span
              :class="
                stepNumber == 2 ? 'c-pink' : stepNumber > 3 ? 'c-primary' : ''
              "
              >مشاهده و خروجی</span
            >
          </div>
        </div>
      </div>
      <div class="d-block d-sm-none text-center py-4">
        <div class="d-flex flex-column justify-content-center c-grey">
          <div class="text-center" @click="stepNumber = 1">
            <span :class="stepNumber == 1 ? 'c-pink' : 'c-primary'"
              >انتخاب موضوعات</span
            >
            <div v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
              (
              <span v-if="selectedCats.length">
                {{ selectedCats.length + " موضوع" }}
              </span>
              )
            </div>
          </div>
          <div class="text-center">
            <v-icon class="mx-5">mdi-chevron-down</v-icon>
          </div>

          <div>
            <v-icon class="mx-5">mdi-chevron-down</v-icon>
          </div>
          <div>
            <span :class="stepNumber == 2 ? 'c-pink' : ''">مشاهده و خروجی</span>
          </div>
        </div>
      </div>
      <hr class="my-4" />
      <!-- Step 1 -->
      <div v-if="stepNumber == 1">
        <div v-if="pageLoading" class="text-center py-16 my-16">
          <fold></fold>
          <p class="c-dark">در حال بارگذاری...</p>
        </div>
        <div v-else>
          <v-row>
            <v-col class="pt-6 text-sm-right text-center">
              <span class="c-dark fs-large"
                >موضوعات مورد نظر خود را انتخاب کنید.</span
              >
            </v-col>
            <v-col sm="6" cols="12">
              <v-text-field
                rounded
                filled
                clearable
                class="search-box mt-2 mt-sm-0"
                placeholder="عنوان موضوع را جستجو کنید..."
                v-model="filter"
              >
                <template v-slot:prepend-inner>
                  <v-icon class="ps-3 pe-3">$searchIcon</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <div v-if="!this.filter" class="mt-1 mb-5">
            <v-btn
              @click="!total ? selectAll() : removeAll()"
              elevation="0"
              class="all-btn"
              >{{ !total ? "همه" : "هیچ" }}</v-btn
            >
          </div>

          <div v-if="!computedCats.length" class="text-center c-grey">
            <hr />
            موردی یافت نشد.
            <hr />
          </div>

          <v-row>
            <v-col
              lg="3"
              md="3"
              sm="4"
              cols="12"
              v-for="(item, index) in computedCats"
              :key="index"
            >
              <div
                class="item-box"
                @click="chooseCat(item)"
                :class="selectedCats.includes(item.name) ? 'selected-box' : ''"
              >
                {{ item.name }}
              </div>
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- Step 2 -->
      <div v-if="stepNumber == 2" class="pb-6">
        <div v-if="pageLoading" class="text-center py-16 my-16">
          <fold></fold>
          <p class="c-dark">در حال بارگذاری...</p>
        </div>
        <div v-else>
          <v-row>
            <v-col>
              <div class="main-table">
                <v-row>
                  <v-col md="6" cols="12">
                    <h5 class="mt-6 fs-xlarge text-sm-right text-center pt-3">
                      گزارش موضوعات
                    </h5>
                  </v-col>
                  <v-col md="6" cols="12">
                    <div class="text-sm-left text-center">
                      <v-btn
                        class="bc-primary text-white btn-radius my-10"
                        width="200"
                        height="47"
                        elevation="0"
                        @click="$refs.table3.$el.click()"
                      >
                        <span class="fs-small">
                          خروجی اکسل
                          <v-icon>$Excel</v-icon></span
                        >
                      </v-btn>
                      <vue-excel-xlsx
                        v-show="false"
                        ref="table3"
                        :data="reportExcel"
                        :columns="excelFields"
                        :filename="'جدول-دانشگاه'"
                        :sheetname="currentDate"
                      >
                        دریافت اکسل
                      </vue-excel-xlsx>
                    </div>
                  </v-col>
                </v-row>

                <b-table
                  responsive
                  small
                  show-empty
                  stacked="sm"
                  tbody-tr-class="trClass"
                  thead-class="thClass"
                  empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                  :items="reportData"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :busy="tableBusy"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(cats)="data">
                    <ul v-if="data.item.cats && data.item.cats.length">
                      <li v-for="(item, i) in data.item.cats" :key="i">
                        {{ i + 1 }}. {{ item }}
                      </li>
                    </ul>
                    <span v-else>-</span>
                  </template>

                  <template v-slot:cell(uniRequests)="data">
                    <ul
                      v-if="
                        data.item.uniRequests && data.item.uniRequests.length
                      "
                    >
                      <li v-for="(req, i) in data.item.uniRequests" :key="i">
                        {{ i + 1 }}. {{ req.faSubject }} ( {{ req.status }})
                      </li>
                    </ul>
                    <span v-else>-</span>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + perPage * (currentPage - 1) + 1 }}
                    </div>
                  </template>
                </b-table>
                <v-row v-if="totalRows">
                  <v-col>
                    <v-pagination
                      v-model="currentPage"
                      :length="Math.ceil(totalRows / perPage)"
                      :total-visible="5"
                      prev-icon="arrow_back"
                      next-icon="arrow_forward"
                      class="float-left"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>

      <v-row v-if="!pageLoading" class="mt-8 w-100">
        <v-col
          class="text-right pe-0 ps-0"
          v-if="stepNumber < 2"
          md="4"
          sm="6"
          cols="12"
        >
          <v-btn
            class="bc-primary text-white no-underline btn-radius w-100 ms-3"
            elevation="0"
            height="43"
            @click="nextStep()"
            :disabled="computedNextButton"
            >گام بعدی</v-btn
          >
        </v-col>
        <v-spacer v-if="stepNumber < 3"></v-spacer>
        <v-col class="text-left pe-0 ps-0" md="4" sm="6" cols="12">
          <v-btn
            class="b-primary bc-white c-primary no-underline btn-radius w-100 ms-3"
            elevation="0"
            height="43"
            @click="previousStep()"
            v-if="stepNumber > 1"
            >گام قبلی</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <div class="goToDown" @click="goDown()">
      <v-icon>mdi-chevron-down</v-icon>
    </div>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import screenShot from "../../../mixins/screenShot";
import Chart from "../../../components/charts/Chart.vue";
import YearModal from "@/components/YearModal";
//import { set } from "vue/types/umd";
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    Chart,
    YearModal,
  },
  mixins: [screenShot],
  data() {
    return {
      filter: "",
      vLoading: false,
      cats: [],
      isSelected: false,
      selectedCats: [],
      selectedCatsIds: [],
      total: false,
      total2: false,
      stepNumber: 1,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      fields: [
        { key: "index", label: "#" },
        { key: "name", label: "عنوان موضوع" },
        { key: "university", label: "نام دانشگاه" },
        { key: "faSubject", label: "عنوان طرح کلان" },
      ],
      excelFields: [
        { field: "name", label: "عنوان موضوع" },
        { field: "university", label: "نام دانشگاه" },
        { field: "faSubject", label: "عنوان طرح کلان" },
      ],
      currentPage: 1,
      totalRows: "",
      perPage: 10,
      perPage2: 10,
      tableBusy: false,
      reportData: [],
      reportExcel: [],
      deviceType: "",
      pageLoading: false,
      reactivity: true,
    };
  },
  methods: {
    goDown() {
      var container = document.querySelector("html");
      var scrollHeight = container.scrollHeight;
      container.scrollTop = scrollHeight;
    },
    chooseCat(item) {
      if (this.selectedCats.length && this.selectedCats.includes(item.name)) {
        let index;
        index = this.selectedCats.indexOf(item.name);
        this.selectedCats.splice(index, 1);
        this.selectedCatsIds.splice(index, 1);
      } else {
        this.selectedCats.push(item.name);
        this.selectedCatsIds.push(item.id);
      }

      if (this.selectedCats.length == this.cats.length) {
        this.total = true;
      } else {
        this.total = false;
      }
    },
    selectAll() {
      this.cats.forEach((x) => {
        if (!this.selectedCats.includes(x.name)) {
          this.selectedCats.push(x.name);
          this.selectedCatsIds.push(x.id);
        }
      });
      this.total = true;

      this.goDown();
    },
    removeAll() {
      this.selectedCats = [];
      this.selectedCatsIds = [];
      this.total = false;
    },
    clearItem(index) {
      this.selectedCats.splice(index, 1);
      this.selectedCatsIds.splice(index, 1);
      this.total2 = false;
      if (!this.selectedCats.length) {
        this.previousStep();
        return;
      }
    },
    nextStep() {
      this.filter = "";
      if (this.stepNumber == 1) {
        if (this.selectedCats.length) {
          ++this.stepNumber;
          this.total2 = false;
          this.getReportInfo();
        } else {
          this.total2 = false;
          this.stepNumber = 1;
        }
      }
      setTimeout(() => {
        document.querySelector("html").scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 100);
    },
    previousStep() {
      this.filter = "";
      if (this.stepNumber == 2 && !this.selectedCats.length) {
        this.stepNumber = 1;
      } else {
        --this.stepNumber;
      }

      setTimeout(() => {
        document.querySelector("html").scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 100);
    },

    getCats() {
      this.pageLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/cats/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.cats = res.data;
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getReportInfo() {
      this.pageLoading = true;
      this.tableBusy = true;

      this.$http
        .post(
          this.baseUrl + "/setad/admin/reports/cats/uniRequests",
          {
            catIds: this.selectedCatsIds,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.reportData = res.data;
            this.reportExcel = this.reportData;
            this.totalRows = this.reportData.length;
            this.tableBusy = false;
          }
        });
      setTimeout(() => {
        this.pageLoading = false;
        this.tableBusy = false;
      }, 4000);
    },
  },
  computed: {
    computedCats() {
      if (this.filter) {
        let filtered;
        filtered = this.cats.filter((x) => x.name.includes(this.filter));
        return filtered;
      } else {
        return this.cats;
      }
    },
    computedNextButton() {
      if (this.stepNumber == 1) {
        if (!this.selectedCats.length) {
          return true;
        } else return false;
      }
    },
  },
  mounted() {
    if (window.screen.width < 500) {
      this.deviceType = "mobile";
    } else {
      if (document.body.clientWidth < 500) {
        this.deviceType = "mobile";
      } else {
        this.deviceType = "desktop";
      }
    }
    this.getCats();
  },
};
</script>
<style lang="scss">
.modal-card {
  border-radius: 10px !important;
  .edit-icon {
    path {
      stroke: #068d9d !important;
    }
    transform: translateY(-2px);
  }
  .v-card__title {
    border-radius: 10px 10px 0 0;
  }
  .day-box {
    width: 37px;
    height: 37px;
    text-align: center;
    border-radius: 50%;
    padding-top: 8px;
    color: #656a81;
    &:hover {
      background-color: #eeeeee;
    }
    &.selected {
      background-color: #e6e6e6;
      color: #068d9d;
      font-weight: bold;
    }
  }
  .small-logoBox {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}
.universities-page {
  min-height: 400px;
  padding: 15px;
}
</style>
